import { Type } from 'class-transformer';
import { UserNameDisplayResultDto } from '../../../_models/user-name-display-result-dto';

export class DocumentHistoryResultDto {
    id: number;
    begin: string;
    end: string;
    action: string;
    @Type(() => Date)
    actionedOn: Date;
    @Type(() => UserNameDisplayResultDto)
    actionedBy: UserNameDisplayResultDto;
    additionalInfo: string;
}
